import { useMemo } from 'react';

import { usePartnerConsentUserConsentQuery } from '../data-access';

export const useUserConsents = () => {
	const { data, isLoading, isRefetching, refetch } = usePartnerConsentUserConsentQuery();
	const hasConsents = useMemo(
		() => !isLoading && data && data?.filter(consent => !!consent.allowed)?.length > 0,
		[data]
	);

	return {
		hasConsents,
		isUserConsentsLoading: isLoading,
		isUserConsentsRefetching: isRefetching,
		refreshUserConsents: refetch,
		userConsents: data || []
	};
};
